<template>
  <div class="contracttype-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('contracttype_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-gavel</v-icon>{{$t('contract.contracttypes')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ContracttypeFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
          <template slot="item.guarantee" slot-scope="{ item }">
            <strong v-if="item.guarantee" >
              <v-icon color="green">mdi-check-circle</v-icon>
            </strong>
            <span v-else>
              <v-icon color="red">mdi-close-circle</v-icon>
            </span>
          </template>
          <template slot="item.maintenance" slot-scope="{ item }">
            <strong v-if="item.maintenance" >
              <v-icon color="green">mdi-check-circle</v-icon>
            </strong>
            <span v-else>
              <v-icon color="red">mdi-close-circle</v-icon>
            </span>
          </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ContracttypeFilterForm from '../../components/contracttype/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ContracttypeList',
  servicePrefix: 'Contracttype',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    ContracttypeFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('contract.duration'), value: 'duration' },
        { text: this.$t('contract.guarantee'), value: 'guarantee' },
        { text: this.$t('contract.maintenance'), value: 'maintenance' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
      footer: {
        'itemsPerPageText': "",
      },

    };
  },
  computed: {
    ...mapGetters('contracttype', {
      items: 'list'
    }),
    ...mapFields('contracttype', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('contracttype', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
